export const formatPhoneNumber = (phoneNumber) => {
  return phoneNumber.replace(')', ') ');
};

export const formatStoreWithAvailability = ({ storeList, inventory }) => {
  return storeList.map((store) => {
    const storeAvailability = inventory.find((item) => item.locationNbr === store.storeId);
    return {
      availableQty: storeAvailability?.availableQty || null,
      ...store
    };
  });
};
